import { $, $$ } from './../helpers/qsa'

export default class {

    mount() {
        this.polls = $$('.poll').map(el => new Poll(el))
    }

}

class Poll {

    constructor(el) {
        this.el = el
        this.id = el.getAttribute('data-poll-id')
        this.hasVoted = localStorage.getItem(`wc/poll/${this.id}`) ? true : false

        this.build()
    }

    async build() {
        try {
            this.data = await this.fetchData()

            if (this.hasVoted || this.data.isClosed) {
                this.renderResults()
            } else {
                this.renderPoll()
            }
        } catch {
            this.el.remove()
        }
    }

    async fetchData() {
        const response = await fetch(`/wp-json/wc/v1/polls/${this.id}`)

        if (response.status !== 200) {
            throw new Error('Error retreiving poll.')
        }

        const json = await response.json()

        return json
    }

    renderPoll() {
        if (!this.data) {
            return
        }

        const { data } = this

        this.el.innerHTML = `
            <h3 class="poll__title">${data.title}</h3>

            <div class="poll__options">
                ${data.options.map(option => `
                    <label class="poll__option">
                        <input type="radio" name="vote" value="${option.id}">
                        <div class="poll__option-label">${option.label}</div>
                    </label>
                `).join('')}
            </div>

            <div class="align-center">
                <button type="button" class="poll__btn">Vote</button>
            </div>
        `

        this.voteBtn = $('.poll__btn', this.el)
        this.voteBtn.addEventListener('click', this.handleVote.bind(this))
    }

    renderResults() {
        if (!this.data) {
            return
        }

        const { data } = this

        // HTML
        let resultsHtml = `<h3 class="poll__title">${data.title}</h3>`

        // Show results?
        if (data.includeVotes) {
            const percentages = this.calculatePercentages(data.options)

            resultsHtml = `
                ${resultsHtml}

                <div class="poll__options">
                    ${data.options.map((option, index) => `
                        <div class="poll__option">
                            <div class="poll__option-label" data-percent="${percentages[index]}%">${option.label}</div>
                            <div class="poll__option-percent" style="width: ${percentages[index]}%"></div>
                        </div>
                    `).join('')}
                </div>
            `
        }

        // Messages
        if (data.isClosed) {
            resultsHtml = `
                ${resultsHtml}

                <div class="align-center">
                    <p>This poll has now closed.</p>
                </div>
            `
        } else if (data.message) {
            resultsHtml = `
                ${resultsHtml}

                <div class="align-center">
                    <p>${data.message}</p>
                </div>
            `
        }

        this.el.innerHTML = resultsHtml
    }

    handleVote() {
        const checked = $$('input', this.el).filter(input => input.checked)

        if (checked.length < 1) {
            return
        }

        // Set up form
        const data = new FormData()
        data.append('vote', checked[0].value)

        // Submit vote
        fetch(`/wp-json/wc/v1/polls/${this.id}`, {
            method: 'POST',
            body: data
        })
        .then(response => {
            if (response.status !== 200) {
                throw new Error('Error casting vote.')
            }

            return response.json()
        })
        .then(json => {
            this.data = json

            // Set voted state
            this.hasVoted = true
            localStorage.setItem(`wc/poll/${this.id}`, checked[0].value)

            this.renderResults()
        })
        .catch(error => {
            alert('There was an error casting your vote. Please try again.')
        })
    }

    calculatePercentages(options) {
        const total = options.reduce((acc, option) => acc + option.votes, 0)
        const percentages = options.map(option => option.votes / total * 100)
        const diff = 100 - percentages.map(value => Math.floor(value)).reduce((acc, value) => acc + value, 0)

        return percentages.map((value, index) => {
            return {
                index: index,
                value: value
            }
        })
        .sort(({ value }) => Math.floor(value) - value)
        .map((p, index) => {
            return {
                index: p.index,
                value: index < diff ? Math.floor(p.value) + 1 : Math.floor(p.value)
            }
        })
       .sort((a, b) => a.index - b.index)
       .map(({ value }) => value)
    }

}
